import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Alert, Collapse, Modal, Col, Row } from 'react-bootstrap';
import { withRouter, Link } from "react-router-dom";
import moment from 'moment'
import _ from 'lodash';

import config from 'react-global-configuration';

import ReactGA from "react-ga";

import { DateHeading, CalendarCenter, FreeSlots, BookingSlot, BookedSlot, GolfCourseHeading, WhiteUnderlineHover } from './../BookingCalendarStyle'
import { ImageSection, Icon, ModalHeading } from '../../GeneralStyle'
import { CompanyImage } from '../MemberProfileStyle'
import persIconWhite from '../../../images/icons/person_double.png';
import persIconGold from '../../../images/icons/person_double_lg_gold.png';
import mailIcon from '../../../images/icons/mail_icon.png';
import calIcon from '../../../images/icons/calendar_lg_gold.png';
import phoneIcon from '../../../images/icons/phone_icon.png';
import creditIcon from '../../../images/icons/credits.png';
import { DoubleBounce } from 'better-react-spinkit'

import bookingUtils from '../../../utils/bookingUtils'

@inject(
  'bookingStore',
  'datesStore',
  'configStore',
  'golfCourseStore'
)

@observer
class ChooseDateModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      showAlert: true
    }

    this.bookingUtils = bookingUtils

    this.closeModal = this.closeModal.bind(this)
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this)
  }

  handlePrev = () => {
    const golfcourse = this.props.bookingStore.golfCourse

    if(!golfcourse) return
    this.props.golfCourseStore.checkBookingLimitation( golfcourse.objectId );
  }

  trackNextWeek() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Next Week - Choose Date Modal'
    });
  }

  trackPrevWeek() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Previous Week - Choose Date Modal'
    });
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  openModal() {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Open - Choose Date Modal'
    });
    this.setState({ showModal: true });
  }

  closeModal() {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Close -  Choose Date Modal '
    });
    this.setState({ showModal: false })
    this.props.bookingStore.setChooseDateModalError(null)
    this.props.bookingStore.setGolfCourse(null)
  }

  handleAlertDismiss() {
    this.props.bookingStore.setChooseDateModalError(null)
  }

  renderBookingSlots(bookings, freeSlots, maxSlots) {
    let bookingSlots = []

    //show oldest booking at first place
    bookings = _.sortBy(bookings, function(dateObj) {
      return new Date(dateObj.createdAt);
    });

    bookings.map((booking, key) => {
      let height = (booking.slots * 120)
      let bgColor = booking["isRemainingStock"] ? "#FD9091" : "#F6F6F6"
      let fontColor = booking["isRemainingStock"] ? null : "#a9a9a9"
      let persIcon = booking["isRemainingStock"] ? persIconWhite : persIconGold


      bookingSlots.push(
        <Link to={"/partner/" + booking.user.toJSON().company.shortname} target="_blank" style={{ textDecoration: "none " }}>
          <BookingSlot key={key} height={height} color={bgColor}>
            <CalendarCenter>
              <CompanyImage size={50} image={`${config.get('CLOUDINARY_URL')}${booking.user.toJSON().company.logo}.png`} />
              <BookedSlot color={fontColor}>{booking.user.toJSON().company.name}</BookedSlot>
              <BookedSlot color={fontColor}><Icon size={16} icon={persIcon} style={{ marginRight: 8 }} /> {booking.slots > 1 ? booking.slots + " Personen" : "Eine Person"}</BookedSlot>
            </CalendarCenter>
          </BookingSlot>
        </Link>
      )
      return true
    })

    _.times(freeSlots, (idx) => {
      bookingSlots.push(
        <BookingSlot height={120} color={"#D9B67B"} style={{ cursor: "pointer" }}>
          <CalendarCenter>
            <FreeSlots marginTop={15} color={"white"}>frei</FreeSlots>
          </CalendarCenter>
        </BookingSlot>
      )
    })

    const bookingDivs = (
      <div>
        {bookingSlots.map(function (bookingContent) {
          return bookingContent
        })}
      </div >
    )
    return bookingDivs
  }

  renderFreeBookings(freeSlots) {
    let freeBookingSlots = []
    _.times(freeSlots, (key) => {
      freeBookingSlots.push(
        <BookingSlot key={key} height={120} color={"#D9B67B"} style={{ cursor: "pointer" }}>
          <CalendarCenter>
            <FreeSlots marginTop={15} color={"white"}>frei</FreeSlots>
          </CalendarCenter>
        </BookingSlot>
      )
    })

    const freeBookingDivs = (
      <div>
        {freeBookingSlots.map(function (bookingContent) {
          return bookingContent
        })}
      </div >
    )
    return freeBookingDivs
  }

  renderBlockedBookings(freeSlots) {

    return (
      <Link to="#" style={{ textDecoration: "none " }}>
      <BookingSlot height={120*freeSlots} color={"#F6F6F6"} style={{cursor: "auto"}}>
        <CalendarCenter>
          <BookedSlot color={"#a9a9a9"} style={{textDecoration: "line-through"}}>geschlossen</BookedSlot>
        </CalendarCenter>
      </BookingSlot>
      </Link>
    )
  }

  performChecks(date, bookings, golfCourse) {
    if (this.bookingUtils.performChecks(date, bookings, golfCourse)) {
      this.props.bookingStore.setGolfCourse(golfCourse)
      this.props.bookingStore.setDate(date)
      this.props.bookingStore.setGolfCourseFreeSlots(
        bookings
          ? bookings.freeSlots
          : golfCourse.slots)
      this.props.bookingStore.setChooseDateModalError(null)
    } else {
      this.props.bookingStore.setChooseDateModalError(this.bookingUtils.getPerformCheckError())
    }
  }

  render() {

    const {
      isChooseDateModalError,
      chooseDateModalError,
      isGolfCourse,
      golfCourse,
      isBookingsPerDate,
      bookingsPerDate } = this.props.bookingStore

    const {
      isDates,
      dates,
      currentWeekNumber,
    } = this.props.datesStore


    const modalSize = "large"

    const datesHeadings = (
      isDates &&
      dates.map(
        (date, key) =>
          <Col sm={1} md={1} lg={1} key={key}>
            <GolfCourseHeading style={{ borderLeft: "solid 1px white" }}>{moment(JSON.stringify(date).substr(1, 10)).locale("de").format('dd DoMM')}</GolfCourseHeading>
          </Col>
      )
    )

    const weekNavigator = (
      <Row>
        <Col sm={3} md={3} lg={3} onClick={() => {this.props.datesStore.getPreviousWeek(); this.handlePrev(); this.trackPrevWeek()}} style={{ cursor: "pointer" }}>
          <GolfCourseHeading>
            &lt;
          </GolfCourseHeading>
        </Col >
        <Col sm={6} md={6} lg={6}>
          <GolfCourseHeading>
            WOCHE {currentWeekNumber - 1}
          </GolfCourseHeading>
        </Col >
        <Col sm={3} md={3} lg={3} onClick={() => {this.props.datesStore.getNextWeek(); this.trackNextWeek()}} style={{ cursor: "pointer" }}>
          <GolfCourseHeading>
            &gt;
          </GolfCourseHeading>
        </Col >
      </Row>
    )

    const bookingSlots = (
      isDates && isBookingsPerDate && isGolfCourse &&
      dates.map((date, key) => {
        let newDate = JSON.stringify(date).substr(1, 10);
        let bookings = bookingsPerDate[newDate];

        let isActive = false
        let isLoading = this.props.golfCourseStore.loadedAfter > date

        for(let time of golfCourse.activeTime) {
          const from = new Date(time.from)
          const to = new Date(time.to)
          to.setDate(to.getDate() + 1)

          if(to >= date && date >= from) {
            isActive = true
          }
        }

        return (
          <Col sm={1} md={1} lg={1} key={key}
            onClick={() => {
              if(isActive) this.performChecks(newDate, bookings, golfCourse)
            }}
          >
            {
              !isActive
              ? this.renderBlockedBookings(golfCourse.slots)
              : isLoading ?
              <BookingSlot height={120} color={"#F6F6F6"} style={{cursor: "auto"}}>
                <span key="key" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                  <BookedSlot color={"#a9a9a9"} style={{textDecoration: "line-through"}}>
                    <DoubleBounce color={"#DAB777"} size={20}/>
                  </BookedSlot>
                </span>
              </BookingSlot>

              : bookings
                ? this.renderBookingSlots(bookings["bookingsOnDate"], bookings["freeSlots"], golfCourse.slots)
                : this.renderFreeBookings(golfCourse.slots)
            }
          </Col >
        )
      })
    )

    return (
      <div>
        {isGolfCourse && isBookingsPerDate
          ?
          <Modal show={this.state.showModal} onHide={this.closeModal} bsSize={modalSize}>
            <ImageSection background={config.get('CLOUDINARY_URL') + golfCourse.calendarPicture + ".jpg"}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <div>
                    <ModalHeading>
                      Ihre Buchung im {golfCourse.courseName}
                    </ModalHeading>
                    <Row>
                      <Col lg={2}></Col>
                      <Col lg={8}>
                        <Row>
                          <Col lg={6}><Icon size={16} icon={phoneIcon} /><WhiteUnderlineHover href={"tel:" + golfCourse.phone} style={{ fontSize: 14, textAlign: "center" }}><p>{golfCourse.phone}</p></WhiteUnderlineHover></Col>
                          <Col lg={6}><Icon size={16} icon={mailIcon} /> <WhiteUnderlineHover href={"mailto:" + golfCourse.email} style={{ fontSize: 14, textAlign: "center" }}><p>{golfCourse.email}</p></WhiteUnderlineHover></Col>
                          <Col lg={6}><Icon size={16} icon={calIcon} /> <WhiteUnderlineHover target={"_blank"} href={golfCourse.tournamentCalendar} style={{ fontSize: 14, textAlign: "center" }}><p>Turnierkalender</p></WhiteUnderlineHover></Col>
                          <Col lg={6}><Icon size={16} icon={creditIcon} /> <p style={{ fontSize: 14, textAlign: "center" }}>{golfCourse.price} Credits / Greenfee</p></Col>
                        </Row>
                        </Col>
                        <Col lg={2}></Col>
                    </Row>
                  </div>
                </Modal.Title>
              </Modal.Header>
            </ImageSection>
            <Modal.Body style={{ paddingTop: 0 }} className={"no-padding-row"}>

              <Collapse in={isChooseDateModalError} style={{ marginTop: 15 }}>
                <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                  <p>{chooseDateModalError}</p>
                </Alert>
              </Collapse>

              <Row>
                <DateHeading>
                  {weekNavigator}
                </DateHeading>
              </Row>
              <Row className={"seven-cols"}>
                <DateHeading color={"#DBDBDB"}>
                  {datesHeadings}
                  <Col sm={1} md={1} lg={1} />
                  <Col sm={1} md={1} lg={1} />
                </DateHeading>
              </Row>
              <Row className={"seven-cols"}>
                {bookingSlots}
              </Row>

            </Modal.Body>
          </Modal>
          : null}
      </div>
    );
  }
}

ChooseDateModal.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  datesStore: MobxPropTypes.observableObject,
  configStore: MobxPropTypes.objectOrObservableObject
};

export default withRouter(ChooseDateModal);



// WEBPACK FOOTER //
// /src/components/internal/BookingModal/ChooseDateModal.js